export const minLevel = 1;
export const maxLevel = 5;
export const sticker_names = ["zebra", "leopard", "acacia", "boabab", "elephantgrass"];